export const BANK_CANNOT_EDIT_STATUS = [
    'Approved',
    'Pending sign L.O',
    'L.O acceptance by client',
    'First draw down',
    'Full disbursement',
    'Rejected',
    'Declined by client',
    'Cancelled',
]

export const BANK_APPROVAL_STATUS = [
    'Approved',
    'Approval',
    'Pending sign L.O',
    'Pending Sign LO',
    'L.O acceptance by client',
    'LO Acceptance',
    'SPA & LA Done',
    'First draw down',
    'First Draw Down',
    'Full disbursement',
    'Full Disbursement',
    'Loan Disbursed',
    'Pending Sign SPA',
    'Downpayment',
    'Pending Booking Fee.'
]

export const BANK_STATUS = [
    {
        value: 'Pending credit score',
        label: 'Pending CCRIS',
        lvl: 1
    },
    {
        value: 'Pending Document',
        label: 'Pending Doc',
        lvl: 2
    },
    {
        value: 'Pending Submission',
        label: 'Pending Banker',
        lvl: 3
    },
    {
        value: 'Pending Booking Form',
        label: 'Pending Booking Form',
        lvl: 4
    },
    {
        value: 'Document checking',
        label: 'Banker Checking',
        lvl: 5
    },
    {
        value: 'Pending Approval',
        label: 'Pending Approval',
        lvl: 6
    },
    {
        value: 'Additional Docs',
        label: 'Additional Docs',
        lvl: 7
    },
    {
        value: 'Processing',
        label: 'Appeal Approval',
        lvl: 8
    },
    {
        value: 'Declined by client',
        label: 'Declined by Client',
        lvl: 9
    },
    {
        value: 'Rejected',
        label: 'Rejected by Bank',
        lvl: 10
    },
    {
        value: 'Cancelled',
        label: 'Cancel Application',
        lvl: 11
    },
    {
        value: 'Approved',
        label: 'Approved',
        lvl: 12
    },
    {
        value: 'Pending sign L.O',
        label: 'Pending sign LO',
        lvl: 13
    },
    {
        value: 'L.O acceptance by client',
        label: 'LO Acceptance',
        lvl: 14
    },
    {
        value: 'Pending LA & SPA',
        label: 'Pending LA & SPA',
        lvl: 15
    },
    {
        value: 'SPA & LA Done',
        label: 'LA & SPA Done',
        lvl: 16
    },
    {
        value: 'First draw down',
        label: 'First Draw Down',
        lvl: 17
    },
    {
        value: 'Full disbursement',
        label: 'Full Disbursement',
        lvl: 18
    },
    {
        value: 'Pending Booking Fee',
        label: 'Pending Booking Fee',
        lvl: 19
    },
    {
        value: 'Downpayment',
        label: 'Downpayment',
        lvl: 20
    },
    {
        value: 'Pending Sign SPA',
        label: ' Pending Sign SPA',
        lvl: 21
    },
]

export const INSURANCE_STATUS = [
    'Pending Banker',
    'Pending Submission',
    'Pending Document',
    'Pending Approval',
    'Approved',
    'Rejected',
    'Declined by client',
    'Cancelled',
]

export const INSURANCE_APPROVED_STATUS = [
    'Policy In force',
    'Policy issued',
    'Pending Payment',
    'Completed',
    'Approved'
]

export const UNEDITABLE_STATUS = [
    'Draft',
    'Application Pending',
    'Application Rejected',
    'Rejected',
    'Declined by client',
    'Cancelled',
    'Revoke'
]

export const APPROVALS_STATUS = [
    'All',
    'Pending',
    'Approved',
    'Rejected',
]

export const COMMITMENT_CAPACITIES = [
    'Own',
    'Joint',
    'Sole',
    'Partner',
    'Prof',
    'Other not in Lists',
]

export const COMMITMENT_FACILITIES = [
    {
        value: "CRDTCARD",
        label: "Credit Card"
    },
    {
        value: "HSLNFNCE",
        label: "Housing Loan (Commercial)"
    },
    {
        value: "OHRPCREC",
        label: "Hire Purchase"
    },
    {
        value: "PCPASCAR",
        label: "Hire Purchase (Car)"
    },
    {
        value: "PELNFNCE",
        label: "Personal Loan"
    },
    {
        value: "PTPTN",
        label: "PTPTN"
    },
    {
        value: "OTH",
        label: "OTH"
    },
    {
        value: "SHMARGIN",
        label: "Share"
    },
    {
        value: "Trade Reference",
        label: "Trade Reference"
    },
    {
        value: "Special Attention",
        label: "Special Attention"
    },
    {
        value: "Legal Status",
        label: "Legal Status"
    },
    {
        value: "Koperasi Loan",
        label: "Koperasi Loan"
    },
    {
        value: "Credit Loan",
        label: "Credit Loan"
    },
    {
        value: "Legal Summon",
        label: "Legal Summon"
    },
    {
        value: "OTLNFNCE",
        label: "Other Loans (Including Personal Loan)"
    },
    {
        value: "ISPWNBKG",
        label: "ISPWNBKG"
    },
    {
        value: "SAA",
        label: "SAA"
    },
    {
        value: "CTOS Section D",
        label: "CTOS Section D"
    }
]

export const COMMITMENT_STATUSES = [
    "CCRIS",
    "AKPK",
    "SAA",
    "Legal",
    "Restructure",
    "Koperasi",
    "Trade Reference",
    "PTPTN - Ujrah",
    "Bankruptcy",
    "Summon",
    "SAS (Legal) - 10",
    "SAA (Legal) - 11",
    "SAA (Legal) - 18",
    "CCRIS (Legal) - 10",
    "CCRIS (Legal) - 11",
    "Others"
]

export const COMMITMENT_SECTIONS = [
    "CTOS Section D",
    "CTOS Section E",
    "Angkasa Section",
    "SAA Section",
    "Other not in Lists",
]

export const PROPOSED_REPAYMENT_VIAS = [
    "KWSP",
    "Personal Loan",
    "Property Cash Back 1",
    "Other",
    "Credit Loan",
    "Disposal of Vehicle",
    "Disposal of Property",
    "Property Cash Back 2",
    "Merchant repayment",
    "Friendly Loan"
]

export const IP_APPROVED_STATUSES = [
    'Accepted',
    'Appeal',
    'Approved by Credit Control',
    'Canceled',
    'Converted to Case',
    'Credit',
    'Pending Accept',
    'Rejected',
    'Rejected by Credit Control',
    'Submitted to Credit Control',
    'Submitted to SSA'
]

export const IP_REJECTED_STATUSES = [
    'Rejected by SSA',
    'Rejected by Credit Control',
]

export const BASKET_DESCRIPTION = {
    'Silver': 'No Input Income / No Purchase of Report.',
    'Green': 'Great profile and eligible for loan application.',
    'Yellow': 'Low-Risk profile but may need some settlement before loan submission.',
    'Orange': 'Medium-Risk profile and may have high outstanding debt or DSR issue.',
    'Pink': 'High-Risk profile with poor repayment record and/or long overdue debts.',
    'Red': 'Poor profile with possibility of outstanding legal cases or under bank blacklist.',
}

export const MAIN_PRODUCTS_LABEL = {
    'property': 'Property',
    'mortgage': 'Mortgage',
    'personal_loan': 'Personal Loan',
    'insurance': 'Insurance',
    'refinance': 'Refinance',
    'credit_card': 'Credit Card',
    'other': 'Other'
}

export const EMAIL_TRIGGER_POINTS = {
    INITIAL_PROPOSAL_STATUS_CHANGE: 'Initial Proposal Status Change',
    INITIAL_PROPOSAL_CLIENT_RESPONSE: 'Initial Proposal Client Response',
    INITIAL_PROPOSAL_SUBMIT_LOAN_APPROVAL: 'Initial Proposal Submit Loan Approval',
    INITIAL_PROPOSAL_RESPONSE_LOAN_APPROVAL: 'Initial Proposal Response Loan Approval',
    CASE_APPROVE: 'Case Approve',
    CASE_REJECT: 'Case Reject',
    CASE_CREATED: 'Case Created',
    LOAN_ADVISORY: 'Send To Advisory',
    ASSIGN_ADVISOR: 'Assign Advisor',
    CASE_PENDING_APPROVAL: 'Case Pending Approval',
    CREATE_CASE_APPROVAL: 'Create Case Approval'
};

export const NOTIFICATION_TRIGGER_POINTS = {
    LEAD_STATUS_CHANGE: 'Lead Status Change',
    CASE_STATUS_CHANGE: 'Case Status Change',
    CUSTOMER_STATUS_CHANGE: 'Customer Status Change',
    CHAT_MESSAGE: 'Chat Message',
    INITIAL_PROPOSAL_STATUS_CHANGE: 'Initial Proposal Status Change',
    INITIAL_PROPOSAL_CLIENT_RESPONSE: 'Initial Proposal Client Response',
    INITIAL_PROPOSAL_SUBMIT_LOAN_APPROVAL: 'Initial Proposal Submit Loan Approval',
    INITIAL_PROPOSAL_RESPONSE_LOAN_APPROVAL: 'Initial Proposal Response Loan Approval',
};
